import { getDownloadURL, ref } from 'firebase/storage';

import { MIME_TYPES } from '../enums/MimeEnum';
import { storage } from '../firebase';

import { generateFirestoreId } from './utils';

export const isImage = (fileType: string) => fileType.startsWith('image/');

export const isPdf = (fileType: string) => fileType === MIME_TYPES.PDF;

/** Determines if a file is an image, using contentType when available and falling back to URL/filename extension. */
export const isImageFile = (contentType?: string, urlOrFilename?: string) => {
  if (contentType) return isImage(contentType);
  if (urlOrFilename) return Boolean(urlOrFilename.match(/\.(jpg|jpeg|png|gif|webp|avif|tiff|bmp|svg)$/i));
  return false;
};

export function generateStorageFileName(prefix?: string | null, suffix?: string | null): string {
  const fileId = generateFirestoreId();
  return `${prefix ? `${prefix}-` : ''}${fileId}${suffix ? `-${suffix}` : ''}`;
}

export async function getFileUrl(storageLocation: string, fileName: string): Promise<string> {
  const fileRef = ref(storage, `${storageLocation}/${fileName}`);
  try {
    return await getDownloadURL(fileRef);
  } catch (error) {
    console.error('Error getting file URL:', error);
    throw error;
  }
}
